import React, { useRef, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import BlogPage from '../../components/sectionBlogListArticles';
import Contact from '../../components/sectionContact';
import Footer from '../../components/sectionFooter';
import Head from 'next/head';
import AppContext from '../../components/context/AppContext';

function Blog(props) {
 //console.log("props", props);

 const { setLangContext } = useContext(AppContext);

 useEffect(() => {
  setLangContext('fr');
 });

 return (
  <div className='flex w-full flex-col '>
   <Head>
    <title>JAMIVIZ - Articles</title>
    <meta property='og:title' content='JAMIVIZ - Articles' />
    <meta name='description' content='Jamiviz est un développeur Web 3D freelance à Montreal - Quebec  , spécialisé en programmation et développement  de sites web 3D.'></meta>
    <meta property='og:description' content='Jamiviz est un développeur Web 3D freelance à Montreal - Quebec , spécialisé en programmation et développement  de sites web 3D. ' />
    <link rel='alternate' href='https://jamiviz.com/articles' hrefLang='fr' />
   </Head>
   <BlogPage recentsArticles={props.recentsArticles} mostViewArticles={props.mostViewArticles} listArticles={props.listArticles} err={props.err} errList={props.errList} errMost={props.errMost} errRecent={props.errRecent} page={props.page} />
   <Contact />
   <Footer />
  </div>
 );
}

export default Blog;

//prettier-ignore
export const getServerSideProps = async ({ query, params }) => {
  let recentsArticles = [];
  let mostViewArticles =[];
  let listArticles = [];
  let errRecent = ""
  let errList = ""
  let errMost = ""

  const apiClient = axios.create({
    headers: {
      'Cache-Control': 'no-store'
    }
  });



  //console.log("=====> querry :", query.page)
 

  try {
   
    
    try {
      recentsArticles = await apiClient.get(`${process.env.NEXT_PUBLIC_origin}/api/articles/recentsArticles`);
      recentsArticles = recentsArticles.data;
      errRecent ="";
    } catch (error) {
      errRecent ="rejected";
      recentsArticles = [];
    }

    try {
      
      mostViewArticles = await apiClient.get(`${process.env.NEXT_PUBLIC_origin}/api/articles/mostViewArticles`);
      mostViewArticles = mostViewArticles.data;
      errMost ="";
    } catch (error) {
      errMost ="rejected";
      mostViewArticles = [];
    }


    try {
      
      listArticles = await apiClient.get(`${process.env.NEXT_PUBLIC_origin}/api/articles/listArticles?page=${query.page}`);
      listArticles = listArticles.data;
      errList ="";
    } catch (error) {
      errList ="rejected";
      listArticles = [];
    }


    

    return { props: { recentsArticles, mostViewArticles,listArticles, page :query.page || 1   , errList, errMost,errRecent, err: "" } };
  } catch (err) {
    console.log("err :", err);
    return {
      props: {
        recentsArticles: recentsArticles.data ? recentsArticles.data : [],
        mostViewArticles: mostViewArticles.data ? mostViewArticles.data : [],
        listArticles: listArticles.data ? listArticles.data : [],
        page :query.page || 1 , 
        errList: "rejected",
        errRecent: "rejected",
        errMost: "rejected",
        err: "rejected",
      },
    };
  }
};
